import { useCallback, useEffect, useState } from 'react';
import ZnalostiSheet from '../components/znalosti/ZnalostiSheet';
import Dokumentace from './prehled/dokumentace/Dokumentace.jsx';
import { REZERVA_LISTY } from '../components/MobilniLista';

/**
 * Znalosti — jedno místo pro všechno, podle čeho se pracuje (od 2026-10-04):
 * **recepty, směrnice a návody**. Dřív byly recepty a směrnice v Přehledu
 * (sekce Dokumentace) a návody v liště (Znalosti) — obsluha musela vědět,
 * kde co leží.
 *
 * Řízená dokumentace (recepty, směrnice) zůstává řízená: „K potvrzení" je
 * nahoře, detail s verzí a „Přečetl jsem" je pořád ten z Dokumentace — tady
 * se jen mění adresa (`znalosti-seznam?druh=…`). Úvod, „Tady se hodí",
 * návody a hledání přes všechno kreslí `ZnalostiSheet` jako stránku.
 *
 * Kde se obsah tvoří, se nemění: recepty v Receptáři, směrnice v modulu
 * Směrnice, návody v modulu Znalosti.
 */
export default function ZnalostiStranka({ user, navParams = {}, onNavigate, isDark, isMobile, onZmena }) {
    const [prehled, setPrehled] = useState(null);   // /api/me/dokumentace — druhy + k_potvrzeni

    const nactiPrehled = useCallback(() => {
        fetch('/api/me/dokumentace', { headers: { Accept: 'application/json' } })
            .then(r => (r.ok ? r.json() : null)).then(d => setPrehled(d || { druhy: [], k_potvrzeni: [] }))
            .catch(() => setPrehled({ druhy: [], k_potvrzeni: [] }));
    }, []);
    useEffect(() => { nactiPrehled(); }, [nactiPrehled, navParams?.druh]);

    // Dokumentace naviguje na „prehled?tab=dokumentace&…" — tady to je tahle stránka
    const naDokumentaci = (_page, params = {}) => {
        const { tab, ...zbytek } = params;
        onNavigate('znalosti-seznam', zbytek);
    };
    const poZmene = () => { nactiPrehled(); onZmena?.(); };

    if (navParams?.druh === 'recepty' || navParams?.druh === 'smernice') {
        return (
            <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', paddingBottom: isMobile ? REZERVA_LISTY : 0 }}>
                <Dokumentace isDark={isDark} user={user} navParams={navParams} onNavigate={naDokumentaci} onZmena={poZmene} />
            </div>
        );
    }

    return (
        <ZnalostiSheet jakoStranka klic={navParams?.z || null} params={{}} isDark={isDark} isMobile={isMobile}
            dokumentace={prehled ? {
                prehled,
                jdi: (params) => onNavigate('znalosti-seznam', { z: 1, ...params }),
            } : null}
            onClose={() => onNavigate('prehled', { tab: 'moje-smena' })} />
    );
}
